/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ExtractRequestBuilderRequestsMetadata, type ExtractRequestBuilder } from './extract/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/customers/business-cards
 */
export interface BusinessCardsRequestBuilder extends BaseRequestBuilder<BusinessCardsRequestBuilder> {
    /**
     * The extract property
     */
    get extract(): ExtractRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const BusinessCardsRequestBuilderUriTemplate = "{+baseurl}/api/customers/business-cards";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const BusinessCardsRequestBuilderNavigationMetadata: Record<Exclude<keyof BusinessCardsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    extract: {
        requestsMetadata: ExtractRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
